import { ArrowUpRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

import { LockedChartCard } from "../locked-chart-card";
import {
  CampaignDetailMock,
  CampaignTableMock,
  SummaryMock,
  TrendChartMock,
} from "./discount-mock-content";

export function PremiumFeatureOverlay() {
  const { t } = useTranslation("reports");

  return (
    <div className="space-y-4">
      {/* Top banner with upgrade CTA */}
      <div className="relative overflow-hidden rounded-2xl border-2 border-amber-300 bg-gradient-to-r from-amber-50 via-white to-orange-50 shadow-sm">
        <div className="relative flex flex-col sm:flex-row sm:items-center gap-4 px-5 py-4">
          <div className="flex items-start sm:items-center gap-3 flex-1 min-w-0">
            <div className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 shadow-sm shadow-amber-400/40">
              <Sparkles className="h-5 w-5 text-white" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
                  {t("premiumFeature.badge")}
                </span>
                <h3 className="text-base sm:text-lg font-semibold text-slate-900">
                  {t("premiumFeature.title")}
                </h3>
              </div>
              <p className="mt-0.5 text-xs sm:text-sm text-slate-600">
                {t("premiumFeature.description")}
              </p>
            </div>
          </div>
          <Button
            asChild
            className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold shadow-md shadow-amber-400/40 shrink-0"
          >
            <Link to="/settings/subscriptions">
              {t("premiumFeature.cta")}
              <ArrowUpRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>

      {/* Locked cards — each blurs its own content with hover lock overlay */}
      <LockedChartCard
        title={t("discounts.summary.title")}
        mockContent={<SummaryMock />}
        height="auto"
      />
      <LockedChartCard
        title={t("discounts.table.title")}
        mockContent={<CampaignTableMock />}
        height="auto"
      />
      <LockedChartCard
        title={t("discounts.detail.trendTitle")}
        mockContent={<TrendChartMock />}
        height="auto"
      />
      <LockedChartCard
        title={t("discounts.detail.serviceBreakdown")}
        mockContent={<CampaignDetailMock />}
        height="auto"
      />
    </div>
  );
}
